import axios from 'axios';
import Auth from '@aws-amplify/auth';
import { CONFIG } from './Config';

const api = axios.create({
  baseURL: CONFIG.backendUrl,
  headers: {
    'Content-Type': 'application/json',
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache',
  },
  responseType: 'json',
});

api.interceptors.request.use(async (config) => {
  const cognitoSession = await Auth.currentSession();
  const idToken = cognitoSession.getIdToken().getJwtToken();
  if (idToken) config.headers['Authorization'] = 'Bearer ' + idToken;
  return config;
});

export const publicApi = axios.create({
  baseURL: 'https://api-dev-open.ixorthink-tst.com',
  headers: {
    'Content-Type': 'application/json',
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache',
  },
  responseType: 'json',
});

export default api;
